import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { appUser } from "@duress/shared";
import { getAppUsers, uploadAppUsers } from "./app-users-api";

function appUsersKey(clientId: string) {
  return ["clients", "app-users", clientId] as const;
}

export function useAppUsers(
  clientId: string,
  options?: { enabled?: boolean },
): {
  data: appUser.AppUserData | undefined;
  isLoading: boolean;
  error: unknown;
  refetch: () => void;
} {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: appUsersKey(clientId),
    queryFn: () => getAppUsers(clientId),
    enabled: (options?.enabled ?? true) && Boolean(clientId),
  });
  return { data, isLoading, error, refetch: () => void refetch() };
}

export function useUploadAppUsers(clientId: string): {
  mutateAsync: (file: File) => Promise<appUser.AppUserData>;
  isPending: boolean;
  error: unknown;
} {
  const qc = useQueryClient();
  const m = useMutation({
    mutationFn: (file: File) => uploadAppUsers(clientId, file),
    onSuccess: (data) => {
      qc.setQueryData(appUsersKey(clientId), data);
    },
  });
  return { mutateAsync: m.mutateAsync, isPending: m.isPending, error: m.error };
}
